<div class="w-full bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm">
  <!-- Header -->
  <div class="flex items-center gap-3 px-4 py-3 border-b border-gray-100 bg-green-50">
    <div class="flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center bg-green-100 text-green-600">
      <lucide-icon [img]="icons.CheckCircle2" class="w-5 h-5"></lucide-icon>
    </div>
    <div class="flex-1 min-w-0">
      <div class="text-sm font-semibold text-gray-900">
        {{ preview().scoringGuide.topic || 'Scoring Guide' }}
      </div>
      <div class="text-xs text-green-600">{{ getSubtitle() }}</div>
    </div>
  </div>

  <!-- Sections -->
  <div class="divide-y divide-gray-100">
    @for (section of preview().scoringGuide.sections; track section.id; let sectionIdx = $index) {
      <div>
        <!-- Section Header -->
        <button
          (click)="toggleSection(section.id)"
          class="w-full px-4 py-2.5 flex items-center gap-2 hover:bg-gray-50 transition-colors cursor-pointer"
        >
          <span
            class="w-5 h-5 rounded-full flex items-center justify-center text-white text-[10px] font-bold flex-shrink-0 bg-violet-500"
          >
            {{ sectionIdx + 1 }}
          </span>
          <span class="font-medium text-gray-800 flex-1 text-left text-xs">{{ section.title }}</span>
          <span class="text-[10px] text-gray-400 flex-shrink-0 mr-1">{{ section.items.length }} items</span>
          <lucide-icon
            [img]="icons.ChevronDown"
            class="w-3.5 h-3.5 text-gray-400 transition-transform duration-200"
            [class.rotate-180]="isSectionExpanded(section.id)"
          ></lucide-icon>
        </button>

        <!-- Section Items (Collapsible) -->
        @if (isSectionExpanded(section.id)) {
          <div class="border-t border-gray-100 bg-gray-50/50">
            @for (item of section.items; track item.id) {
              <div class="px-4 py-2.5 border-b border-gray-100 last:border-b-0">
                <!-- Item Header Row -->
                <div class="flex items-start gap-1.5 mb-1.5">
                  <span class="px-1 py-0.5 text-[9px] font-bold rounded bg-violet-100 text-violet-700 flex-shrink-0">
                    #{{ item.questionIdentifier }}
                  </span>
                  <span
                    class="px-1 py-0.5 text-[9px] font-medium rounded-full flex-shrink-0"
                    [class.bg-purple-100]="item.type === 'rubric'"
                    [class.text-purple-700]="item.type === 'rubric'"
                    [class.bg-blue-100]="item.type === 'logic'"
                    [class.text-blue-700]="item.type === 'logic'"
                    [class.bg-green-100]="item.type === 'exact_match'"
                    [class.text-green-700]="item.type === 'exact_match'"
                  >
                    {{ getItemTypeLabel(item.type) }}
                  </span>
                  <span class="px-1 py-0.5 text-[9px] font-medium rounded bg-gray-100 text-gray-600 flex-shrink-0">
                    {{ getItemMaxPoints(item) }} pts
                  </span>
                </div>

                <!-- Question Text (truncated) -->
                <p class="text-[11px] text-gray-600 leading-tight line-clamp-2 mb-2">{{ item.questionText }}</p>

                <!-- Criteria Display using ScoringGuideTable -->
                <app-scoring-guide-table
                  [item]="item"
                  [standards]="preview().scoringGuide.standards"
                />
              </div>
            }
          </div>
        }
      </div>
    }
  </div>

  <!-- Summary Footer -->
  <div class="px-4 py-2.5 bg-gray-50 border-t border-gray-100">
    <div class="flex items-center gap-3 text-[10px] text-gray-500">
      <div class="flex items-center gap-1">
        <lucide-icon [img]="icons.Award" class="w-3 h-3"></lucide-icon>
        <span>{{ preview().summary.totalPoints }} total points</span>
      </div>
      @if (preview().summary.standardsAligned) {
        <div class="flex items-center gap-1">
          <lucide-icon [img]="icons.BookOpen" class="w-3 h-3"></lucide-icon>
          <span>{{ preview().summary.standardsAligned }} standards</span>
        </div>
      }
    </div>
  </div>
</div>
